var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThankYouLocal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.1 185.5C389.6 209.3 396.5 283.3 341 362.9C249.9 493.5 134 459.3 94.3997 358.2C51.0997 247.3 256.1 124.6 352.1 185.5Z",
    fill: "#EA662B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.9 199.9C365.9 199.9 382 161.5 382.3 160C383.7 153 408.6 155.1 407.2 150.8C405.5 145.4 386.8 145.8 382.5 144.5C378 143.1 360.4 146.2 360.4 146.2C360.4 146.2 343 142 344.1 148.8C345.4 157 356.6 149.6 358.9 168.2C359.6 174 349.5 195 349.5 195L365.9 199.9Z",
    fill: "#FF7945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M341 252.8C354 252.5 390.9 176.4 390.9 176.4L355.9 171.4C355.9 171.4 345.4 193.4 335.1 209.5C325.1 202.4 295.7 168.6 282.3 161.1C278.8 159.1 264.7 163.8 264.5 167.9L268.5 222C268.5 221.9 295.5 254 341 252.8Z",
    className: "illustration_primary_default"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.3 340.7L157.5 225.7C157.5 160.4 168.9 161.5 176.7 159.3C191.4 155.3 203 147.9 236.8 147.9C264.2 147.9 273.9 152.5 282.3 161.1C296.4 175.4 289.6 202.8 289.6 248L304.2 341.2C304.2 386.3 174.3 385.8 174.3 340.7Z",
    className: "illustration_primary_default"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2 329.3H172.3V364.4H304.2V329.3Z",
    className: "illustration_primary"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M286.2 270.9L290 192.7",
    stroke: "#131A46",
    strokeWidth: 5.7662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.1 195.3L247.5 303.9",
    stroke: "#131A46",
    strokeWidth: 5.7662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M276.6 221.7L337.5 234.8L318.2 330.5L260.1 320.6L276.6 221.7Z",
    fill: "#FFE600"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.1 164.4C187.1 168.7 237.1 194.5 237.1 194.5C237.1 194.5 242.5 195.5 245.3 192.4C245.3 192.4 263.1 160.1 253.2 155.5C237 147.9 191.1 160.1 189.1 164.4Z",
    className: "illustration_primary-lightest"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.1 329.9C223.1 329.9 240.6 334.3 264.8 335.6C266.7 335.7 268.6 335.9 270.5 336.1C279.3 337.2 288.8 335.3 293.9 333C300.3 330.2 281.5 327.6 281.5 327.6C281.5 327.6 299.8 330.6 300.3 324.8C300.6 321.3 296.8 318.4 290 317.8C297.2 318.3 300.3 318.5 302.8 314.6C305.6 310.2 291.2 308.9 289 308.7C290.9 308.6 302 311.9 303.1 306.1C304.3 300.1 274.9 299.2 274.9 299.2C274.9 299.2 285.7 300.5 285.2 294.8C284.8 289.1 248.8 298.6 241.8 300.8C234.8 303 224 297.2 224 297.2L223.1 329.9Z",
    fill: "#FF7945"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M176.7 159.3C160.9 162.2 153.8 178.7 146.8 209.5C144.5 219.8 139.5 273.7 141.7 295.8C144 317.9 147.8 316.9 165.7 322.4C176.7 325.8 209.1 341 245.6 343.2C255.3 343.8 256.9 346.2 256.8 341.1C256.8 341.1 257.3 297.7 249.7 296.5L206.6 291.8C198.5 290.6 192.6 283.5 192.8 275.4L182.8 210.1C182.9 207.6 199.4 155.1 176.7 159.3Z",
    className: "illustration_primary_default"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M239 105.5C241.5 117.6 239 152.9 241.4 159C243.7 164.9 235.4 185.8 208.3 168.9C206.4 167.7 205.2 165.7 205 163.5L198 95.4001C198 95.4001 232.8 75.7001 239 105.5Z",
    fill: "#FF7945"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M256.1 51.6001C261.6 70.3001 263.3 91.1001 264.4 118.9C265.1 136.3 248 149.3 224.2 138.5C199.5 127.2 189.3 112.2 189.1 91.1001C189.1 85.1001 184.8 73.0001 188.1 66.4001C194.6 53.7001 254.3 45.5001 256.1 51.6001Z",
    fill: "#FF7945"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M259.7 51C268.9 58.3 259.7 58.7 259.7 58.7C259.7 58.7 263 62.1 259.4 65C251.8 71.1 241.4 61.4 241.4 61.4C241.4 61.4 242.8 65.5 231.5 67.4C228.1 68 224.1 64.4 224.1 64.4C224.1 64.4 222.4 67.7001 216.1 68.8001C209.8 69.9001 206.9 76.1 206.9 76.1C207.7 77.1 207.2 93.7001 203.7 97.5C202.7 98.6 199.2 95.7 199.2 95.7C199.2 95.7 202.1 111.8 194.6 112.7C185.4 113.9 181.1 71.1 188.9 60.1C196.6 49.5 233.6 30.4 259.7 51Z",
    className: "illustration_primary"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199 116.3C199 116.3 192.3 117.5 188.9 115C183.9 111.3 183.4 101.2 186.1 95.9001C188.8 90.7001 198.1 93.6001 200.7 97.3001",
    fill: "#FF7945"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M240 125.4C240 125.4 231.5 128 221.7 119.8",
    stroke: "black",
    strokeWidth: 3.3484,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M243.1 94.5C243.1 94.5 250.9 106.7 249.5 110.7C248.1 114.7 238.5 114.2 238.5 114.2",
    stroke: "black",
    strokeWidth: 3.3484,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.847 96.5595C229.642 96.2445 230.857 94.6221 230.562 92.9357C230.266 91.2493 228.571 90.1375 226.775 90.4525C224.98 90.7674 223.765 92.3898 224.061 94.0762C224.356 95.7626 226.052 96.8744 227.847 96.5595Z",
    className: "illustration_primary"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M251.548 92.4483C253.343 92.1333 254.559 90.5109 254.263 88.8245C253.967 87.1381 252.272 86.0263 250.477 86.3413C248.681 86.6562 247.466 88.2786 247.762 89.965C248.058 91.6514 249.753 92.7632 251.548 92.4483Z",
    className: "illustration_primary"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M196 107.4C196 107.4 198.3 99.1001 192.5 101.3",
    stroke: "black",
    strokeWidth: 3.3484,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M203.3 124.6C203.3 124.6 208.4 135.3 223.5 138.1",
    stroke: "black",
    strokeWidth: 1.1689,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M218.2 87.4L229.6 84",
    stroke: "#131A46",
    strokeWidth: 2.4554,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M245.3 81.1001L255.5 80.7001",
    stroke: "#131A46",
    strokeWidth: 2.4554,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M397.7 64.8V59.2C397.7 56.5 395.5 55.9 392.8 55.9H390.1C387.4 55.9 385.2 56.5 385.2 59.2V64.8C379.8 66.1 375.7 71 375.7 76.9V133.9H407.3V76.9C407.2 71.1 403.2 66.2 397.7 64.8Z",
    fill: "#2A9DD6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M174.3 217.6L182.6 276.1",
    stroke: "#131A46",
    strokeWidth: 5.7662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M243.7 299.3L168.4 277.9",
    stroke: "#131A46",
    strokeWidth: 5.7662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5 106.5C323.8 101.3 317.4 97.3001 310.5 96.1001C290.8 94.6001 277.9 126.2 274.2 142.1C271.6 152.5 270.1 163.3 269.5 174C269.4 175.3 269.3 176.7 269.1 178C268 186 265.2 193.7 261.5 200.7C237.6 244 177.5 272.4 128.8 269.9C102.5 268.6 78.1998 256.9 64.0998 233.6C51.4998 214.1 40.7998 190 48.3998 166.4C51.5998 156.4 58.7998 147.3 67.1998 141.5C78.3998 133.8 90.8998 129.9 104.4 130C113.7 129.9 121.3 137.5 121.2 146.8C121.1 155.9 113.6 163.2 104.4 163.1C97.7998 162.3 89.9998 163.9 84.3998 167.3C79.1998 170.5 76.0998 174.5 74.8998 180.5C72.4998 192.6 79.3998 209 85.8998 220.4C98.8998 246.7 130.6 252 157.6 248.3C192.7 243.5 231.5 225 251.1 194.6C255.2 187.9 258.2 180.6 259.2 172.8L259.7 169.1C261.2 159.1 263.3 149.2 266.5 139.6C271.4 125.3 278.1 111 289.5 100.5C296.6 93.8001 307.4 89.2001 316.7 94.6001C321.8 97.2001 326.3 100.9 329.6 105.6C329.8 105.9 329.7 106.2 329.5 106.4C329.1 106.9 328.7 106.8 328.5 106.5Z",
    fill: "#FFE600"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M327.3 126.1C335.363 126.1 341.9 119.563 341.9 111.5C341.9 103.437 335.363 96.9 327.3 96.9C319.236 96.9 312.7 103.437 312.7 111.5C312.7 119.563 319.236 126.1 327.3 126.1Z",
    fill: "#7A4E30"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M342.4 117.2C346.431 117.2 349.7 113.932 349.7 109.9C349.7 105.868 346.431 102.6 342.4 102.6C338.368 102.6 335.1 105.868 335.1 109.9C335.1 113.932 338.368 117.2 342.4 117.2Z",
    fill: "#4A2D16"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M338.7 123.1C337 121.1 332.3 117.2 337.8 112.9C343.3 108.5 345.8 111.5 345.8 111.5C345.8 111.5 340.9 107.2 344.8 101.9C348.7 96.6 354.3 101.9 354.3 101.9C354.3 101.9 349.3 92.5 359.1 92.2C368.9 91.9 362.2 102.2 362.2 102.2C362.2 102.2 369.9 100 368.5 108.8C367.1 117.6 359.3 114.1 359.3 114.1C359.3 114.1 364.8 121.5 361.5 125.6C358.1 129.6 342.1 127 338.7 123.1Z",
    fill: "#1DB55D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6 117.8C351.3 118 350.9 118 350.6 117.8C350.2 117.5 350 116.9 350.3 116.4C350.3 116.4 352.6 113.1 353.8 111.4C354.6 110.2 356.2 105.4 357 102.4C357.1 101.9 357.7 101.6 358.2 101.7C358.7 101.8 359 102.4 358.9 102.9C358.7 103.7 356.7 110.7 355.4 112.5C354.2 114.2 351.9 117.4 351.9 117.5C351.9 117.6 351.8 117.7 351.6 117.8Z",
    fill: "#5AC486"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M365.6 122.4C371.067 122.4 375.5 117.968 375.5 112.5C375.5 107.032 371.067 102.6 365.6 102.6C360.132 102.6 355.7 107.032 355.7 112.5C355.7 117.968 360.132 122.4 365.6 122.4Z",
    fill: "#C04F29"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M365.6 120C369.742 120 373.1 116.642 373.1 112.5C373.1 108.358 369.742 105 365.6 105C361.457 105 358.1 108.358 358.1 112.5C358.1 116.642 361.457 120 365.6 120Z",
    fill: "#CD7254"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M370.7 115.8L369.6 115.9C369 115.9 368.4 116.4 368.3 117L368 118.1C367.7 119.3 366.1 119.6 365.4 118.6L364.8 117.7C364.4 117.2 363.8 116.9 363.2 117.1L362.1 117.4C360.9 117.8 359.8 116.5 360.4 115.4L360.9 114.4C361.2 113.8 361 113.1 360.6 112.7L359.8 111.9C358.9 111 359.4 109.5 360.7 109.4L361.8 109.3C362.4 109.3 363 108.8 363.1 108.2L363.4 107.1C363.7 105.9 365.3 105.6 366 106.6L366.6 107.5C367 108 367.6 108.3 368.2 108.1L369.3 107.8C370.5 107.4 371.6 108.7 371 109.8L370.5 110.8C370.2 111.4 370.4 112.1 370.8 112.5L371.6 113.3C372.5 114.1 371.9 115.7 370.7 115.8Z",
    fill: "#D9957F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M321.5 115C315.9 120.8 313.3 120.2 311.2 118.2C309.2 116.2 308.5 113.6 314.1 107.8C319.7 102 329.2 102.1 329.2 102.1C329.2 102.1 327.1 109.2 321.5 115Z",
    fill: "#17964A"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 106.6C322.5 106.6 308.5 118.5 306.6 122.9",
    stroke: "#158743",
    strokeWidth: 1.2528,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M360.1 121.5L359.2 124.6C359.2 124.6 334.5 117 324.2 114.8C323.1 114.6 324.1 112 325.1 111.7C332.5 109 360.1 121.5 360.1 121.5Z",
    fill: "#E57C35"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M325.1 111.6C332.5 109 359.8 121.4 359.8 121.4",
    stroke: "#CC6E2F",
    strokeWidth: 1.2606,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M370.4 136.7H311.6C304.5 136.7 298.8 130.9 298.8 123.9V116.6H383.2V123.9C383.2 130.9 377.5 136.7 370.4 136.7Z",
    className: "illustration_primary_default"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M256.1 241C258.751 241 260.9 238.851 260.9 236.2C260.9 233.549 258.751 231.4 256.1 231.4C253.449 231.4 251.3 233.549 251.3 236.2C251.3 238.851 253.449 241 256.1 241Z",
    className: "illustration_primary-lightest"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M304.8 469.7H161.6L172.9 362.9H304.2L304.8 469.7Z",
    className: "illustration_primary_default"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M258.7 265C261.351 265 263.5 262.851 263.5 260.2C263.5 257.549 261.351 255.4 258.7 255.4C256.049 255.4 253.9 257.549 253.9 260.2C253.9 262.851 256.049 265 258.7 265Z",
    className: "illustration_primary-lightest"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M218.232 209.528L194.43 211.687L194.863 216.467L218.665 214.309L218.232 209.528Z",
    className: "illustration_primary-lightest"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M293.9 469.7H197.5L208.8 362.9H293.3L293.9 469.7Z",
    className: "illustration_primary"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M430.4 92.3H427.9V132.9H430.4V92.3Z",
    className: "illustration_primary_default"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M377.1 78.1V135H405.8V78.1C390.9 85.8 388.6 70.3 377.1 78.1Z",
    className: "illustration_primary_default"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M249.2 418.9L195 422.3V279.9L248.3 294.9L249.2 418.9Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M463.5 132.9V138.4C463.5 143.5 460.1 147.6 456 147.6H299.2C295.1 147.6 291.7 143.5 291.7 138.4V132.9H463.5Z",
    className: "illustration_primary"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M444.1 96H414.2V112.8H444.1V96Z",
    fill: "#FFE600"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M328.4 245.3L323.6 239.3C322.6 238.1 320.9 237.9 319.7 238.9L297.6 256.7L289.1 246.1C288.7 245.6 288.1 245.3 287.5 245.2C286.9 245.1 286.2 245.3 285.7 245.7L280.2 250.1C279.2 250.9 279 252.5 279.8 253.5L290.1 266.3L294.9 272.3L295.1 272.5C295.5 273 296.1 273.3 296.7 273.4C297.3 273.5 298 273.3 298.5 272.9L304 268.5L328 249.2C328.6 248.7 328.9 248.1 329 247.3C329.1 246.5 328.9 245.9 328.4 245.3Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M137.7 107.4C140.516 107.4 142.8 105.117 142.8 102.3C142.8 99.4834 140.516 97.2001 137.7 97.2001C134.883 97.2001 132.6 99.4834 132.6 102.3C132.6 105.117 134.883 107.4 137.7 107.4Z",
    fill: "#FFE600"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M121.6 177C124.417 177 126.7 174.717 126.7 171.9C126.7 169.083 124.417 166.8 121.6 166.8C118.783 166.8 116.5 169.083 116.5 171.9C116.5 174.717 118.783 177 121.6 177Z",
    fill: "#FFE600"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M113.3 102.6L114.6 102C114.9 101.9 115.1 101.6 115.2 101.2L115.4 99.8001C115.5 99.0001 116.6 98.6001 117.2 99.3001L118.2 100.3C118.4 100.5 118.8 100.7 119.1 100.6L120.5 100.4C121.3 100.3 122 101.2 121.5 101.9L120.8 103.1C120.6 103.4 120.6 103.8 120.8 104.1L121.4 105.4C121.8 106.2 121.1 107 120.3 106.9L118.9 106.6C118.6 106.5 118.2 106.6 118 106.9L117 107.9C116.4 108.5 115.4 108.1 115.3 107.3L115.1 105.9C115.1 105.6 114.9 105.3 114.6 105.1L113.3 104.4C112.5 104.1 112.5 103 113.3 102.6Z",
    fill: "#FFE600"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M146 126.1L147.8 128.5C148.2 129.1 148.9 129.4 149.6 129.4L152.6 129.3C154.4 129.2 155.5 131.2 154.5 132.7L152.8 135.1C152.4 135.7 152.3 136.4 152.6 137.1L153.7 139.9C154.3 141.6 152.8 143.3 151.1 142.7L148.3 141.8C147.6 141.6 146.9 141.7 146.3 142.2L144 144.1C142.6 145.2 140.5 144.3 140.5 142.5L140.4 139.5C140.4 138.8 140 138.1 139.4 137.7L136.9 136.1C135.4 135.1 135.7 132.8 137.4 132.2L140.2 131.2C140.9 131 141.4 130.4 141.6 129.7L142.4 126.8C142.7 125.1 144.9 124.7 146 126.1Z",
    fill: "#FFE600"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9998 112.9L63.1998 114.4C63.4998 114.8 63.8998 115 64.3998 114.9L66.2998 114.8C67.3998 114.7 68.1998 116 67.4998 117L66.3998 118.6C66.0998 119 66.0998 119.5 66.1998 119.9L66.8998 121.7C67.2998 122.8 66.2998 123.8 65.1998 123.5L63.3998 123C62.9998 122.9 62.4998 123 62.0998 123.2L60.5998 124.4C59.6998 125.1 58.3998 124.5 58.2998 123.3V121.4C58.2998 120.9 58.0998 120.5 57.6998 120.3L56.0998 119.3C55.0998 118.7 55.2998 117.2 56.3998 116.8L58.1998 116.2C58.5998 116 58.9998 115.7 59.0998 115.3L59.5998 113.5C59.8998 112.3 61.2998 112 61.9998 112.9Z",
    fill: "#FFE600"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.459 155.07L131.104 156.355L131.348 159.847L149.704 158.561L149.459 155.07Z",
    fill: "#FFE600"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4158 97.5672L84.3711 109.454L86.6321 112.125L100.677 100.239L98.4158 97.5672Z",
    fill: "#FFE600"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M144.845 92.2591L159.352 103.579L161.505 100.819L146.999 89.4997L144.845 92.2591Z",
    fill: "#FFE600"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M147.9 112.8C147.5 111.5 148.7 110.3 149.9 110.6L153.6 111.5L157.3 112.4C158.6 112.7 159.1 114.3 158.2 115.2L155.6 118L153 120.8C152.1 121.8 150.5 121.4 150.1 120.1L149 116.5L147.9 112.8Z",
    fill: "#FFE600"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M394.6 60.7001V69.0001C394.6 69.0001 402.8 71.0001 402.8 80.1001C402.8 89.2001 402.8 90.3001 402.8 90.3001",
    stroke: "#F5F6FC",
    strokeWidth: 2.3874,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M395.5 90.4001C396.825 90.4001 397.9 89.3256 397.9 88.0001C397.9 86.6746 396.825 85.6001 395.5 85.6001C394.174 85.6001 393.1 86.6746 393.1 88.0001C393.1 89.3256 394.174 90.4001 395.5 90.4001Z",
    className: "illustration_primary-lightest"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M386.7 96.7C387.639 96.7 388.4 95.9389 388.4 95C388.4 94.0612 387.639 93.3 386.7 93.3C385.761 93.3 385 94.0612 385 95C385 95.9389 385.761 96.7 386.7 96.7Z",
    className: "illustration_primary-lightest"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M397.9 114.3C398.839 114.3 399.6 113.539 399.6 112.6C399.6 111.661 398.839 110.9 397.9 110.9C396.961 110.9 396.2 111.661 396.2 112.6C396.2 113.539 396.961 114.3 397.9 114.3Z",
    className: "illustration_primary-lightest"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M397.9 58C397.9 55 398 54.4 395.2 54.4H388.2C385.4 54.4 385 55 385 58H397.9Z",
    className: "illustration_primary"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M345.6 76.7C350.4 83.2 349.4 85.6 347.1 87.3C344.8 89 342.1 89.3 337.3 82.8C332.5 76.3 334.1 67 334.1 67C334.1 67 340.8 70.3 345.6 76.7Z",
    fill: "#17964A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M337.4 74.4C337.4 74.4 347 90.1 351 92.6",
    stroke: "#158743",
    strokeWidth: 1.2528,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThankYouLocal);
export default __webpack_public_path__ + "static/media/ThankYouLocal.6014cb56.svg";
export { ForwardRef as ReactComponent };